class ContentProviderHtmlElement {
  constructor(element, data) {
    this.element = element;
    this.data = typeof data === 'undefined' ? null : data;
  }

  /*
      returns Promise
    */
  getContent() {
    return new Promise(
      (resolve, reject) => {
        if (this.element !== null) {
          resolve({
            html: this.element.innerHTML,
            data: this.data,
          });
        } else {
          reject(new Error('Element does not exist'));
        }
      }
    );
  }
}

export default ContentProviderHtmlElement;



// WEBPACK FOOTER //
// ./src/js/lib/modals/content_providers/ContentProviderHtmlElement.js